export default __webpack_public_path__ + "static/media/freq.9950b41d.svg";